import * as React from "react";
import { Pressable, StyleProp, TextStyle } from "react-native";
import { useTheme, Headline, IconButton, Paragraph } from "react-native-paper";
import { Block } from "@block";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";

export interface SubtitleNavTitleBar {
  name: string;
  onPressSubtitle: (index: number) => void;
}

type PressAbleState = Readonly<{
  pressed: boolean;
  hovered?: boolean;
  focused?: boolean;
}>;

interface NavTitleBarProps {
  title: string;
  subtitles?: Array<SubtitleNavTitleBar>;
}

export const NavTitleBar = (props: NavTitleBarProps) => {
  const { title, subtitles = [] } = props;
  const { colors, fonts } = useTheme();
  const isDesktop = useDesktopMediaQuery();

  const titleStyles: StyleProp<TextStyle> = { color: colors.accent, ...fonts.semibold };
  const subtitleStyles: StyleProp<TextStyle> = { ...fonts.medium, fontSize: 14, color: colors.accent };
  const lastlySubtitleStyles: StyleProp<TextStyle> = {
    ...fonts.medium,
    fontSize: 14,
    color: colors.accent,
    textDecorationLine: "underline",
  };
  if (subtitles?.length === 0) {
    throw new Error("Subtitle length must be great than zero");
  }

  return (
    <Block pv={spacing.large} ph={isDesktop ? spacing.galactic : spacing.large}>
      <Headline style={titleStyles}>{title}</Headline>
      <Paragraph>
        {subtitles?.map((item, index) => {
          return (
            <React.Fragment key={index}>
              {index === subtitles.length - 1 ? (
                <Pressable>
                  {({ hovered }: PressAbleState) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const captionStyle = useAnimatedStyle(() => {
                      return {
                        // paddingHorizontal: hovered ? 0 : 98,
                        transform: [
                          {
                            scale: hovered ? withSpring(1.1) : withSpring(1),
                          },
                        ],
                      };
                    });
                    return (
                      <Animated.Text onPress={() => item.onPressSubtitle(index)} style={[lastlySubtitleStyles, captionStyle]}>
                        {item.name}
                      </Animated.Text>
                    );
                  }}
                </Pressable>
              ) : (
                <Pressable>
                  {({ hovered }: PressAbleState) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const captionStyle = useAnimatedStyle(() => {
                      return {
                        // paddingHorizontal: hovered ? 0 : 98,
                        transform: [
                          {
                            scale: hovered ? withSpring(1.1) : withSpring(1),
                          },
                        ],
                      };
                    });
                    return (
                      <Animated.Text onPress={() => item.onPressSubtitle(index)} style={[subtitleStyles, captionStyle]}>
                        {item.name}
                      </Animated.Text>
                    );
                  }}
                </Pressable>
              )}
              {index !== subtitles.length - 1 && <IconButton color={colors.accent} icon="chevron-right" size={10} />}
            </React.Fragment>
          );
        })}
      </Paragraph>
    </Block>
  );
};
